import { getEnv } from 'src/constants/config.constants';

export const getDdRumConfig = () => ({
  applicationId: '9e56c040-6a4f-4a87-9f35-0948ee69bfdd',
  clientToken: 'pubf79602b06cb94741e57240141f1d8d4c',
  site: 'datadoghq.com',
  service: 'student-home',
  sampleRate: 5,
  version: 'e7296544899e1a861ba6febd8fa044d0e99a8faa',
  sessionSampleRate: 5,
  sessionReplaySampleRate: 5,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  env: getEnv(),
});
